import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Dashboard } from "./components/Dashboard";
import { Login } from "./components/Login";
import { SSOCallback } from "./components/SSOCallback";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Auth from "./components/Auth";
import { BillingRouter } from "./components/billing/BillingRouter";

import { useAuthSession } from "./hooks/useAuthSession";
import { LoadingSpinner } from "./components/LoadingSpinner";

export default function App() {
  const { pendingAuth, isSignedIn, isLoaded } = useAuthSession();

  if (!isLoaded) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }
  return (
    <div className="min-h-screen w-full">
      {/* Analytics tracking component */}
      <SignedIn>
        <AnalyticsTracker />
      </SignedIn>

      <Routes>
        {/* SSO Callback Route - must be accessible without authentication */}
        <Route path="/sso-callback" element={<SSOCallback />} />

        {/* Auth Route - requires authentication */}
        <Route
          path="/auth/:sessionId"
          element={isSignedIn ? <Auth /> : <Navigate to="/" replace />}
        />

        {/* Root route and main app */}
        <Route
          path="/"
          element={
            <>
              <SignedOut>
                <Login />
              </SignedOut>
              <SignedIn>
                {pendingAuth ? (
                  <Navigate to={`/auth/${pendingAuth}`} replace />
                ) : (
                  <Dashboard />
                )}
              </SignedIn>
            </>
          }
        />

        <Route
          path="/billing"
          element={isSignedIn ? <BillingRouter /> : <Navigate to="/" replace />}
        />

        {/* Catch-all route for any unmatched paths */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
